import { datasourceSelector, datasourceTypeSelector } from 'Features/App/Dictionaries/selectors';
import { getStationDatasourcePath } from 'Features/StationsNew/Datasources/Components';
import { useSelector } from 'react-redux';

export const useDatasourceInfo = (datasourceId: number) => {
  const datasource = useSelector(datasourceSelector(datasourceId));
  const datasourceType = useSelector(datasourceTypeSelector(datasource?.datasourceTypeId));
  const name = `[id:${datasourceId}] ${datasource ? datasourceType.fullName : ''}`;

  if (!datasource) return { name, path: null };

  const path = getStationDatasourcePath({ stationId: datasource.stationId, datasourceId });

  return { name, path };
};
